import { createDataFetchSlice } from '../../../utils/dataFetch';


export const adminReportsPaymentsExcelSlice = createDataFetchSlice<
    string
>({ name: 'paymentsExcel' });
